export default __webpack_public_path__ + "static/media/development-structure-function.47409b24.svg";